<template>
    <section>
        <h2>Срок подачи табелей</h2>
        <b-form-checkbox :checked="value.enabled === true" switch @change="set('enabled', $event)">
            Требовать соблюдение срока подачи
        </b-form-checkbox>
        <p class="text-muted mt-2">Переключатель действует после сохранения, в том числе для уже начатых месяцев. При отключении просрочка не блокирует подачу и срок исправления при возврате не требуется. Заданные даты сохраняются.</p>
        <fieldset :disabled="!value.enabled">
            <p>Официальные табели с сентября 2026 года. Время — 23:59:59 по Минску (UTC+3), без переноса выходных.</p>
            <label>Число следующего месяца
                <b-form-input :value="value.day" type="number" min="1" max="31" class="deadline-day" @input="set('day', Number($event))" />
            </label>
            <p class="text-muted">Изменение правила действует со следующего табельного месяца. У уже начатых месяцев срок сохраняется — для них задайте исключение ниже. Если выбранного числа нет, срок — последний день следующего месяца.</p>
            <h3>Исключения по месяцам</h3>
            <div v-for="(row, index) in value.overrides" :key="index" class="deadline-override">
                <label>Табель за <input type="month" min="2026-09" :value="row.month" class="form-control" @input="changeOverride(index, 'month', $event.target.value)"></label>
                <label>Подать не позднее <input type="date" :value="row.due_date" class="form-control" @input="changeOverride(index, 'due_date', $event.target.value)"></label>
                <b-button variant="outline-danger" size="sm" @click="removeOverride(index)">Удалить</b-button>
            </div>
            <b-button size="sm" variant="outline-primary" @click="set('overrides', value.overrides.concat({month: '', due_date: ''}))">Добавить исключение</b-button>
            </fieldset>
        <p class="mt-4">Согласующие задаются в <router-link to="/requests/types">настройках типа заявки «Продление срока подачи табеля»</router-link>.
            Достаточно одного согласующего. Если их несколько, все рассматривают параллельно; действует самая ранняя из одобренных дат. Изменение состава применяется к новым заявкам.</p>
    </section>
</template>
<script>
export default {
    name: 'TimesheetSubmissionSettings',
    props: {value: {type: Object, required: true}},
    methods: {
        set(key, value) { this.$emit('input', Object.assign({}, this.value, {[key]: value})); },
        changeOverride(index, key, value) { this.set('overrides', this.value.overrides.map((row, i) => i === index ? Object.assign({}, row, {[key]: value}) : row)); },
        removeOverride(index) { this.set('overrides', this.value.overrides.filter((_, i) => i !== index)); }
    }
};
</script>
<style scoped>
h2 { font-size: 1.2rem; } h3 { font-size: 1rem; }
.deadline-day { max-width: 120px; }
.deadline-override { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
</style>
